export const ToastTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components regardless of their passed test id
    getToastBase: () => 'toast',
    getToastCloseButtonBase: () => [ToastTestIdFactory.getToastBase(), 'close'].join('-'),
    getToastLabelBase: () => [ToastTestIdFactory.getToastBase(), 'label'].join('-'),
    getToastMessageBase: () => [ToastTestIdFactory.getToastBase(), 'message'].join('-'),
    // for test id generation
    getToastTestId: (testId) => [ToastTestIdFactory.getToastBase(), testId].join('-'),
    getToastCloseButtonTestId: (testId) => [ToastTestIdFactory.getToastCloseButtonBase(), testId].join('-'),
    getToastLabelTestId: (testId) => [ToastTestIdFactory.getToastLabelBase(), testId].join('-'),
    getToastMessageTestId: (testId) => [ToastTestIdFactory.getToastMessageBase(), testId].join('-'),
};
